import { useEffect, useState } from "react";
export const useUserCentricsConsents = () => {
    const [UCPurposesConsent, setUCPurposesConsent] = useState([]);
    const [UCConsentHasChanged, setUCConsentHasChanged] = useState(false);
    // Fired by UserCentrics when its UI is ready.
    const UC_INIT_EVENT = "UC_UI_INITIALIZED";
    // Fired by UserCentrics when the user just saved consent preferences.
    const UC_INTERACT_EVENT = "UC_UI_CMP_EVENT";
    const [isUcReady, setUcReady] = useState(false);
    useEffect(() => {
        const loadUserCentrics = () => {
            setUcReady(true);
            savePreferences();
        };
        const savePreferences = () => {
            var _a;
            const USCEPurposesConsent = (_a = window.UC_UI) === null || _a === void 0 ? void 0 : _a.getServicesBaseInfo();
            if (!USCEPurposesConsent) {
                console.warn("UC_UI.getServicesBaseInfo is not available");
                return;
            }
            const status = { action: "onSpaView", event: "consent_status" };
            const UCConsents = [];
            USCEPurposesConsent.forEach((purpose) => {
                status[purpose.name] = purpose.consent.status;
                UCConsents.push({ [purpose.name]: status[purpose.name] });
            });
            const givenConsents = UCConsents.filter((obj) => Object.values(obj)[0] === true).map((obj) => Object.keys(obj)[0]);
            setUCPurposesConsent(givenConsents);
        };
        const handleUcInteractions = () => {
            savePreferences();
            setUCConsentHasChanged(true);
        };
        const removeEventListeners = () => {
            window.removeEventListener(UC_INIT_EVENT, loadUserCentrics);
            window.removeEventListener(UC_INTERACT_EVENT, handleUcInteractions);
        };
        window.addEventListener(UC_INIT_EVENT, loadUserCentrics, {
            once: true,
        });
        window.addEventListener(UC_INTERACT_EVENT, handleUcInteractions);
        return removeEventListeners;
    }, []);
    return { UCPurposesConsent, isUcReady, UCConsentHasChanged };
};
